<template>
  <div class="title">
    <div>
      <div>
        {{ english }}
      </div>
      <div>{{ chinese }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "customTitle",
  props: ["chinese", "english"],
};
</script>

<style lang="scss" scoped>
.title {
  width: 100%;
  display: flex;
  justify-content: center;
  > div {
    width: 1000px;
    position: relative;
    > div:nth-child(1) {
      width: 1000px;
      letter-spacing: 5px;
      font-size: 70px;
      color: #ffffff;
      opacity: 7%;
      position: absolute;
      top: 0;
      left: 0;
    }
    > div:nth-child(2) {
      width: 1000px;
      line-height: 80px;
      color: #ffffff;
      background-image: url(../assets/Home/titBg.png);
      background-size: 25%;
      background-repeat: no-repeat;
      background-position: center;
      font-size: 30px;
      letter-spacing: 10px;
      z-index: 2;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}
@media screen and (max-width: 800px) {
  .title {
    > div:nth-child(1) {
      width: 80%;
      > div {
        width: 100%;
      }
      > div:nth-child(1) {
        font-size: 32px;
      }
      > div:nth-child(2) {
        background-size: 60%;
        font-size: 25px;
      }
    }
  }
}
</style>